
export const QueryBuilderCombinators = [
  { name: 'and', label: 'AND' },
  { name: 'or', label: 'OR' },
  // { name: 'not', label: 'NOT' },
];;
